import React, { useCallback, useEffect, useState } from "react";
import { useSession } from "../hooks/session";
import Spinner from "./Spinner";
import Cytoscape from "./Cytoscape";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NodeSearch from "./secondary/NodeSearch";
import LegendCompartments from "./secondary/LegendCompartments";

const Graph = ({ sessionId, selectElements, setLayoutFns, layoutFns }) => {
  const { data, isLoading } = useSession(sessionId);
  const [msgVisible, setMessageVisible] = useState(true);

  const showMsg = useCallback(() => {
    setMessageVisible(true);
  }, [sessionId]);

  const hideMsg = useCallback(() => {
    setMessageVisible(false);
  }, [sessionId]);

  useEffect(() => {
    showMsg();

    const timer = setTimeout(() => hideMsg(), 10000);
    return () => clearTimeout(timer);
  }, [showMsg, hideMsg]);

  if (isLoading)
    return (
      <Spinner size={"4x"} style={{ gridRow: "2/3", gridColumn: "1/2" }} />
    );

  let msgClasses = ["messageGraphDIV"];
  if (!msgVisible) {
    msgClasses.push("msgDivHidden");
  }
  let msgClassesJoined = msgClasses.join(" ");

  return (
    <div className="graph">
      <Cytoscape
        key={sessionId}
        sessionId={sessionId}
        elements={data.cy_network}
        selectElements={selectElements}
        setCallbacks={setLayoutFns}
        allowed_conversion={data.allowed_conversion}
        pathwayInternalId={data.pathwayInternalId}
        network_type={data.network_type}
        protein_type={data.protein_type}
        header_label={data.userColorImported.header_label}
      />
      <div className={msgClassesJoined}>
        <div className={"messageGraph"}>{data.message}</div>
        <div className={"closeMessageGraph"} onClick={hideMsg}>
          <FontAwesomeIcon icon="times" size="lg" />
        </div>
      </div>
      <NodeSearch searchNode={!!layoutFns ? layoutFns.searchNode : () => {}} />
      {!!layoutFns ? (
        <LegendCompartments
          compounds={getCompounds(data.cy_network.nodes)}
          highlightNodesByCompound={layoutFns.highlightNodesByCompound}
          removeAllHighlights={layoutFns.removeAllHighlights}
        />
      ) : null}
    </div>
  );
};

export default Graph;

const getCompounds = (nodes) => {
  const cmps = {};

  nodes.forEach((node) => {
    if (
      !(node.data.location in cmps) &&
      node.data.node_type !== "powernode" &&
      node.data.location !== ""
    ) {
      cmps[node.data.location] = node.data.color;
    }
  });

  return cmps;
};
